import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import "@fontsource/inter";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { getToken, getMessaging, onMessage } from "firebase/messaging";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import "./firebase/firebase-config";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC0wz02EN8E6pgUCm9q-R-GhQ-NopuC-ik",
  authDomain: "pzr-lccutracker.firebaseapp.com",
  projectId: "pzr-lccutracker",
  storageBucket: "pzr-lccutracker.appspot.com",
  messagingSenderId: "87969819792",
  appId: "1:87969819792:web:5e2259f34b615887c63c15",
  vapidKey:
    "BAmrHh6_m5znpVo9-XYPgrCpmHEJQJXjBnifzn2hknm-Yvbt_6o7gVMGmzLcRagOQO0IyofmfRAFngZHCcmFzIE",
  databaseURL:
    "https://pzr-lccutracker-default-rtdb.europe-west1.firebasedatabase.app",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();
const sendMessage = getMessaging(firebase.initializeApp(firebaseConfig));

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
      return navigator.serviceWorker.ready; // Wait for the service worker to be ready
    })
    .then((registration) => {
      console.log("Service Worker is ready:", registration);
      return messaging.getToken({ vapidKey: firebaseConfig.vapidKey });
    })
    .then((token) => {
      console.log("FCM Token:", token);
      // Send the token to your server and save it
      return fetch("/api/save-token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Token saved successfully:", data);
    })
    .catch((error) => {
      console.error("Error getting FCM token:", error);
    });
}

onMessage(messaging, (payload) => {
  console.log("Message received. ", payload);
  const notificationTitle = payload.notification?.title || "Notification";
  const notificationOptions = {
    body: payload.notification?.body,
    icon: "/firebase-logo.png",
  };
  new Notification(notificationTitle, notificationOptions);
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// //Service worker register
// serviceWorkerRegistration.register();

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
